import type { MeasurementType } from '../../data/measurementTypes.ts'

export const isMeasurementTypeBlacklisted = (measurementType: MeasurementType, blacklistType: BlacklistType = 'global') => {
	return blacklists[blacklistType].some((blacklistedValues) => {
		const blacklistedKeys = Object.keys(blacklistedValues) as (keyof MeasurementType)[]
		return blacklistedKeys.every((key) => blacklistedValues[key] === measurementType[key])
	})
}

const globalBlacklist: Partial<MeasurementType>[] = [
	{ statistic: 'STANDARD_DEVIATION' },
	{ parameter: 'WIND_SPEED', period: 'PT5M' },
	{ parameter: 'WIND_DIRECTION', period: 'PT5M' },
	{ parameter: 'DOMINANT_POLLUTANT' },
	{ parameter: 'REFLECTIVITY_FACTOR' },
]

const graphBlacklist: Partial<MeasurementType>[] = [
	...globalBlacklist,
	{ parameter: 'WIND_DIRECTION', statistic: 'MAXIMUM' },
	{ parameter: 'WIND_DIRECTION', statistic: 'MINIMUM' },
	{ parameter: 'WIND_GUST_DIRECTION' },
	{ parameter: 'PRESENT_WEATHER' },
]

const tableBlacklist: Partial<MeasurementType>[] = [...globalBlacklist]

const blacklists: Record<BlacklistType, Partial<MeasurementType>[]> = {
	global: globalBlacklist,
	table: tableBlacklist,
	graph: graphBlacklist,
	none: [],
}

type BlacklistType = 'global' | 'table' | 'graph' | 'none'
